var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small",class:_vm.normStatus},[_c('doughnut-chart',{attrs:{"id":"waste-gauge-chart","height":300,"width":720,"chart-data":_vm.gaugeData,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }